import { getController } from '@/services/service'

const url = 'report_statuses'

export const reportStatusService = {
	...getController<Api.ReportStatus, Api.PostReportStatusPostInput>(url),
}

export default reportStatusService
